import { debounce, type DebounceOptions } from 'es-toolkit';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const _debounce = <T extends (...args: any[]) => void>(
    func: T,
    wait = 25,
    options?: DebounceOptions
): T & { cancel: () => void; flush: () => void; schedule: () => void } =>
    debounce(func, wait, options) as never;

export { _debounce as debounce };
